module.exports = __webpack_public_path__ + "static/mace_of_terror-e299107b12bc8ea86201d0f7f42f7291.jpeg";